import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import { EDialogAction } from "../Components/Enum/DialogActionEnum";
import JobTitlesTable from "../Components/JobTitles/JobTitlesTable";
import JobTitlesDialogBox from "../Components/JobTitles/JobTitlesDialogBox";
import JobSkillDialogBox from "../Components/JobSkills/JobSkillDialogBox";
import { Button } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import Scaffold from "../Components/Layout/Scaffold";

const JobTitle = () => {
  let [hide, setHide] = useState(true);

  let [filter, setfilter] = useState<any>({});
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [textInput, setTextInput] = useState("");

  const handleTextInputChange = (event: any) => {
    setTextInput(event.target.value);
  };

  function hideDiv() {
    if (hide == true) {
      setHide(false);
    } else {
      setHide(true);
    }
  }

  function changeFilters(key: string, value: string) {
    setfilter((oldState: any) => {
      return { ...oldState, [key]: value };
    });
  }

  function clearData() {
    setfilter({});
  }
  function clearSearch() {
    setTextInput("");
    changeFilters("keyword", "");
  }

  function editDialogClose() {
    setEditDialogVisibility(false);
    changeFilters("timestamp", "" + Date.now());
  }

  return (
    <Scaffold
      title="Job Titles"
      mainAction={
        <Button variant="contained"
          color="primary"
          onClick={() => {
            setEditDialogVisibility(true);
          }}
          startIcon={<AddIcon fontSize="small" />}
        >
          Create
        </Button>
      }

      actions={[
        <Box
            component="form"
            sx={{
              "& .MuiTextField-root": {
                maxWidth: "75ch",
              },
            }}
            noValidate
            autoComplete="off"
          >
            <div>
              <TextField
                id="outlined-search"
                type="search"
                label="Search"
                variant="outlined"
                inputProps={{
                  style: {
                    width: "300px",
                    fontSize: "14px",
                  },
                }}
                size="small"
                placeholder="Enter search keyword"
                value={textInput}
                onChange={handleTextInputChange}
              />
            </div>
          </Box>,
          <Button
            endIcon={<SearchOutlined />}
            className="mx-2"
            variant="contained"
            color="secondary"
            onClick={() => {
              changeFilters("keyword", "" + textInput);
            }}>
            Search
          </Button>
      ]}

    >
      <div>
        <JobTitlesTable filter={filter} />
        <JobTitlesDialogBox
          open={editDialogVisibility}
          onClose={editDialogClose}
          data={{}}
          dialogAction={EDialogAction.create}
        />
      </div>

    </Scaffold>
  )

  return (
    <>
      <p className="text-2xl mb-3 ">Job Titles</p>
      <div className="flex flex-col md:flex-row">
        <div className="flex">
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": {
                maxWidth: "75ch",
              },
            }}
            noValidate
            autoComplete="off"
          >
            <div>
              <TextField
                id="outlined-search"
                type="search"
                label="Search"
                variant="outlined"
                inputProps={{
                  style: {
                    width: "300px",
                    fontSize: "14px",
                  },
                }}
                size="small"
                placeholder="Enter search keyword"
                value={textInput}
                onChange={handleTextInputChange}
              />
            </div>
          </Box>

          <Button
            endIcon={<SearchOutlined />}
            className="mx-2"
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => {
              changeFilters("keyword", "" + textInput);
            }}>
            Search
          </Button>
        </div>
        <div className="flex md:w-full md:justify-end ">
          <Button variant="contained"
            color="primary"
            onClick={() => {
              setEditDialogVisibility(true);
              console.log(editDialogVisibility);
            }}
            startIcon={<AddIcon fontSize="small" />}
          >
            Create
          </Button>

        </div>
      </div>
      {/* <div className="flex   space-x-2 mt-6 md:mt-4 -ml-4 md:-ml-3">
        <button
          className="flex bg-green-600 hover:bg-green-500 text-white font-bold pr-4 pl-2 rounded-lg ml-4 h-8"
          onClick={hideDiv}
        >
          <div className="flex text-center ">
            <div className="flex text-center mt-2">
              <FilterAltIcon fontSize="small" />

              <p className="text-sm ml-1">More Filters</p>
            </div>
          </div>
        </button>
      </div> */}
      {/* {!hide ? (
        <div>
          <div className="flex w-full mt-4">
            {/* <div className="flex ">
              <DateRangePicker />
            </div> */}

      {/* <div className="flex">
        <div>
          <FormControl size="small" sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="demo-simple-select-standard-label">Type</InputLabel>
            <Select
              style={{
                width: 150,
                height: 30,
                fontSize: 14,
                marginTop: 5,
              }}
              size="small"
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={filter["type[eq]"] || ""}
              onChange={(event) => {
                changeFilters("type[eq]", event.target.value);
              }}
            >
              <MenuItem value={"dom"}>Domestic</MenuItem>
              <MenuItem value={"corp"}>Corporate</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div> */}
      {/* <div className="flex mt-2">
              <TextField
                id="title"
                variant="outlined"
                style={{ width: 160 }}
                onChange={(event) => {
                  changeFilters("title[eq]", event.target.value);
                }}
                placeholder="Title"
                size="small"
                name="title"
              />
            </div> */}
      {/* <div className="space-x-2 mt-6 md:mt-3 -ml-4 md:ml-3">
              <button
                className="flex bg-blue-800 hover:bg-blue-500 text-white font-bold py-1 pr-4 pl-2 rounded-lg ml-4 text-sm"
                onClick={() => {
                  changeFilters("timestamp", "" + Date.now());
                }}
              >
                <p className="text-sm ml-1">Search</p>
              </button>
            </div>
            <div
              className="space-x-2 mt-6 md:mt-3 -ml-4 md:ml-3"
              onClick={clearData}
            >
              <button>
                <CancelIcon className="mt-1" fontSize="small" />
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}  */}
      <div>
        <JobTitlesTable filter={filter} />
      </div>
      <div>
        <JobTitlesDialogBox
          open={editDialogVisibility}
          onClose={editDialogClose}
          data={{}}
          dialogAction={EDialogAction.create}
        />
      </div>
    </>
  );
};

export default JobTitle;
